import React from 'react';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const cookies = new Cookies();

/* الخادم ينتظر DD/MM/YYYY — نفس صيغة بقية التقارير */
const fmtDate = (d) => {
    const x = (d instanceof Date) ? d : new Date(d);
    if (isNaN(x.getTime())) return '';
    const p = n => (n < 10 ? '0' : '') + n;
    return `${p(x.getDate())}/${p(x.getMonth() + 1)}/${x.getFullYear()}`;
};

/* ⚠️ المبالغ مخزّنة بالنظام «بالألف دينار» (الأصفار الثلاثة محذوفة
   عند الإدخال) — فالعرض يضربها ×1000 لإرجاعها لقيمتها الحقيقية.
   هذا للمبالغ فقط: الأعداد (عدد أجهزة/دفعات/قوائم) لا تمر من هنا. */
const K = 1000;

const iqd = (n) => {
    const x = Number(n);
    if (!isFinite(x)) return '—';
    return Math.round(x * K).toLocaleString('en-US');
};

/* اختصار: 64,120 مخزّنة ⟵ تُعرض "64.1 مليون" */
const short = (n) => {
    const x = (Number(n) || 0) * K;
    const a = Math.abs(x);
    if (a >= 1000000) return (Math.round(x / 100000) / 10) + ' مليون';
    if (a >= 1000) return (Math.round(x / 100) / 10) + ' ألف';
    return Math.round(x).toLocaleString('en-US');
};

const C = {
    canvas: '#eef2f7', surface: '#ffffff', line: '#dfe6ee',
    ink: '#0f172a', muted: '#64748b',
    green: '#059669', red: '#dc2626',
    warn: '#b45309', warnBg: '#fef3c7', okBg: '#ecfdf5', badBg: '#fef2f2'
};

const S = {
    page: { direction: 'rtl', background: C.canvas, minHeight: '100vh', padding: '18px', fontFamily: 'inherit' },
    wrap: { maxWidth: 760, margin: '0 auto' },
    card: { background: C.surface, border: `1px solid ${C.line}`, borderRadius: 14, padding: 18, marginBottom: 14 },
    label: { display: 'block', fontSize: 12, color: C.muted, marginBottom: 4 },
    btn: {
        background: '#4f46e5', color: '#fff', border: 'none', borderRadius: 8,
        padding: '10px 24px', fontSize: 14, cursor: 'pointer'
    },
    btnGhost: {
        background: '#fff', color: C.ink, border: `1px solid ${C.line}`, borderRadius: 8,
        padding: '8px 16px', fontSize: 13, cursor: 'pointer'
    },
    linkBtn: {
        background: 'none', border: 'none', color: '#4f46e5', fontSize: 13,
        cursor: 'pointer', padding: '6px 0'
    },
    row: { display: 'flex', justifyContent: 'space-between', padding: '7px 0', fontSize: 14 },
    num: { direction: 'ltr', textAlign: 'left', whiteSpace: 'nowrap' },
    chip: {
        background: '#f1f5f9', borderRadius: 6, padding: '4px 10px',
        fontSize: 12, color: C.muted, display: 'inline-block'
    },
    err: { background: C.badBg, border: '1px solid #fecaca', color: C.red, borderRadius: 8, padding: 10, marginBottom: 12, fontSize: 13 }
};

class FinanceReport extends React.Component {
    constructor(props) {
        super(props);
        const today = new Date();
        const monthAgo = new Date();
        monthAgo.setDate(monthAgo.getDate() - 30);

        this.state = {
            from: monthAgo, to: today,

            loading: false, error: '', searched: false,
            cash: null,        // حركة الفلوس
            movement: null,    // المخزون والمشتريات والمطابقة

            showLeakDetails: false,
            showClosings: false,

            closings: [],
            cashNow: null,
            invNow: null,
            preview: null, closingBusy: false, closingMsg: ''
        };
    }

    headers = () => ({ "Content-Type": "application/json", token: cookies.get("token") });

    componentDidMount() {
        this.loadClosings();
        this.loadCashNow();
        this.loadInventoryNow();
    }

    loadInventoryNow = () => {
        axios.get(`${host}finance/inventory`, { headers: this.headers() })
            .then(res => this.setState({ invNow: (res.data && res.data.data) || null }))
            .catch(() => { });
    };

    loadCashNow = () => {
        axios.get(`${host}finance/cash`, { headers: this.headers() })
            .then(res => this.setState({ cashNow: (res.data && res.data.data) || null }))
            .catch(() => { });
    };

    loadClosings = () => {
        axios.get(`${host}finance/closings`, { headers: this.headers() })
            .then(res => this.setState({ closings: (res.data.data && res.data.data.closings) || [] }))
            .catch(() => { });
    };

    fetchAll = () => {
        const { from, to } = this.state;
        const d1 = fmtDate(from), d2 = fmtDate(to);
        if (!d1 || !d2) { this.setState({ error: 'اختر فترة صحيحة' }); return; }

        this.setState({ loading: true, error: '' });
        Promise.all([
            axios.get(`${host}finance/cashflow?from=${d1}&to=${d2}`, { headers: this.headers() }),
            axios.get(`${host}finance/movement?from=${d1}&to=${d2}`, { headers: this.headers() })
        ])
            .then(([cashRes, movRes]) => {
                this.setState({
                    cash: (cashRes.data && cashRes.data.data) || null,
                    movement: (movRes.data && movRes.data.data) || null,
                    loading: false, searched: true
                });
            })
            .catch(err => {
                const msg = (err.response && err.response.data && err.response.data.message)
                    || 'تعذّر جلب التقرير. تأكد من الاتصال وأعد المحاولة.';
                this.setState({ loading: false, error: msg });
            });
    };

    /* ── التثبيت اليدوي ── */
    openClosingPreview = () => {
        this.setState({ closingBusy: true, closingMsg: '' });
        axios.get(`${host}finance/closing/preview`, { headers: this.headers() })
            .then(res => this.setState({ preview: res.data.data || null, closingBusy: false }))
            .catch(() => this.setState({ closingBusy: false, closingMsg: 'تعذّرت المعاينة' }));
    };

    confirmClosing = () => {
        const name = cookies.get("name") || '';
        this.setState({ closingBusy: true });
        axios.post(`${host}finance/closing`, { closed_by: name, notes: '' }, { headers: this.headers() })
            .then(res => {
                if (res.data.error) {
                    this.setState({ closingBusy: false, closingMsg: res.data.error, preview: null });
                } else {
                    this.setState({ closingBusy: false, closingMsg: 'تم التثبيت ✓', preview: null });
                    this.loadClosings();
                    this.loadInventoryNow();
                }
            })
            .catch(() => this.setState({ closingBusy: false, closingMsg: 'فشل التثبيت' }));
    };

    /* ═══════════ ٠) الكاش الموجود هسه ═══════════ */
    renderCashNow = () => {
        const cn = this.state.cashNow;
        if (!cn) return null;
        const cash = Number(cn.cash) || 0;
        const st = cn.since_then || {};
        const baseAt = cn.base && cn.base.at ? String(cn.base.at).slice(0, 10) : null;

        return (
            <div style={Object.assign({}, S.card, { textAlign: 'center', background: '#eef2ff', borderColor: '#c7d2fe' })}>
                <div style={{ fontSize: 13, color: C.muted }}>الكاش الموجود عندك هسه</div>
                <div style={{
                    fontSize: 34, fontWeight: 700, direction: 'ltr',
                    color: cash >= 0 ? '#4f46e5' : C.red, margin: '6px 0 2px'
                }}>
                    {iqd(cash)}
                </div>
                <div style={{ fontSize: 12, color: C.muted }}>
                    {baseAt
                        ? `آخر صافي قاصة (${baseAt}): ${short(cn.base.remaining)}`
                        : 'ما مسوّى صافي قاصة بعد'}
                    {' '}+ استلمت بعده {short(st.shipping_in)}
                    {' '}− طلع بعده {short((Number(st.lists_cash) || 0) + (Number(st.spending) || 0) + (Number(st.supplier_payments) || 0))}
                </div>
                <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>
                    نفس رقم الخزينة بالضبط — يتصفّر الفرق كل ما يسوّي المحاسب «صافي قاصة»
                </div>
            </div>
        );
    };

    /* ═══════════ ١) صافي حركة الفلوس ═══════════ */
    renderNet = () => {
        const cash = this.state.cash;
        if (!cash) return null;
        const net = Number(cash.net) || 0;
        const up = net >= 0;

        return (
            <div style={Object.assign({}, S.card, { textAlign: 'center' })}>
                <div style={{ fontSize: 13, color: C.muted }}>
                    من {cash.from} إلى {cash.to} — {up ? 'زادت فلوسك بـ' : 'نقصت فلوسك بـ'}
                </div>
                <div style={{
                    fontSize: 34, fontWeight: 700, direction: 'ltr',
                    color: up ? C.green : C.red, margin: '6px 0 2px'
                }}>
                    {iqd(Math.abs(net))}
                </div>
                <div style={{ fontSize: 12, color: C.muted }}>
                    دينار — دخل {short(cash.money_in.total)} وخرج {short(cash.money_out.total)}
                </div>
            </div>
        );
    };

    /* ═══════════ ٢) فلوس دخلت ═══════════ */
    renderMoneyIn = () => {
        const cash = this.state.cash;
        if (!cash) return null;
        const mi = cash.money_in;

        return (
            <div style={S.card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <div style={{ fontWeight: 700 }}>فلوس دخلت</div>
                    <div style={{ fontSize: 24, fontWeight: 700, direction: 'ltr', color: C.green }}>
                        {iqd(mi.total)}
                    </div>
                </div>
                <div style={{ marginTop: 8 }}>
                    <div style={S.row}>
                        <span>استلمت من شركات التوصيل ({mi.shipping_payments.count} دفعة)</span>
                        <span style={Object.assign({}, S.num, { color: C.green })}>{iqd(mi.shipping_payments.amount)}</span>
                    </div>
                    {mi.supplier_loans.amount > 0 ? (
                        <div style={S.row}>
                            <span>قرضة من تاجر ({mi.supplier_loans.count}) — <span style={{ color: C.warn }}>دين رح يرجع، مو دخل</span></span>
                            <span style={S.num}>{iqd(mi.supplier_loans.amount)}</span>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    };

    /* ═══════════ ٣) فلوس خرجت ═══════════ */
    renderMoneyOut = () => {
        const cash = this.state.cash;
        if (!cash) return null;
        const mo = cash.money_out;

        return (
            <div style={S.card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <div style={{ fontWeight: 700 }}>فلوس خرجت</div>
                    <div style={{ fontSize: 24, fontWeight: 700, direction: 'ltr', color: C.red }}>
                        {iqd(mo.total)}
                    </div>
                </div>
                <div style={{ marginTop: 8 }}>
                    <div style={S.row}>
                        <span>دفعات للتجار ({mo.supplier_payments.count}) — أجهزة وقطع غيار وتسديد آجل</span>
                        <span style={S.num}>{iqd(mo.supplier_payments.amount)}</span>
                    </div>
                    <div style={S.row}>
                        <span>نقد مدفوع مع قوائم المنزلية ({mo.household_lists_cash.count} قائمة)</span>
                        <span style={S.num}>{iqd(mo.household_lists_cash.amount)}</span>
                    </div>
                    <div style={S.row}>
                        <span>المصاريف</span>
                        <span style={S.num}>{iqd(mo.spending_total)}</span>
                    </div>
                    {mo.shipping_refunds.amount > 0 ? (
                        <div style={S.row}>
                            <span>رجّعت مستحقات لشركة توصيل ({mo.shipping_refunds.count})</span>
                            <span style={S.num}>{iqd(mo.shipping_refunds.amount)}</span>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    };

    /* ═══════════ ٤) المصاريف مفككة ═══════════ */
    renderExpenses = () => {
        const cash = this.state.cash;
        if (!cash) return null;
        const sp = cash.spending || [];

        return (
            <div style={S.card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <div style={{ fontWeight: 700 }}>المصاريف — على شنو راحت؟</div>
                    <div style={{ fontSize: 20, fontWeight: 700, direction: 'ltr' }}>
                        {iqd(cash.money_out.spending_total)}
                    </div>
                </div>
                <div style={{ marginTop: 8 }}>
                    {sp.length === 0 ? (
                        <div style={{ fontSize: 13, color: C.muted }}>ما أكو مصاريف مسجّلة بالفترة</div>
                    ) : sp.map(s => (
                        <div style={S.row} key={s.name}>
                            <span>{s.name} ({s.count})</span>
                            <span style={S.num}>{iqd(s.amount)}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    /* ═══════════ ٥) اشتريت بضاعة بـ ═══════════ */
    renderPurchases = () => {
        const m = this.state.movement;
        if (!m) return null;
        const p = m.purchases;

        return (
            <div style={S.card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <div style={{ fontWeight: 700 }}>اشتريت بضاعة بـ</div>
                    <div style={{ fontSize: 24, fontWeight: 700, direction: 'ltr' }}>{iqd(p.total)}</div>
                </div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
                    <span style={S.chip}>أجهزة {short(p.devices.value)} ({p.devices.count} جهاز)</span>
                    <span style={S.chip}>منزلية {short(p.household.value)} ({p.household.count} قائمة)</span>
                    <span style={S.chip}>قطع غيار {short(p.spare.value)} ({p.spare.count} قائمة)</span>
                </div>
                <div style={{ marginTop: 8, fontSize: 12, color: C.muted }}>
                    هاي قيمة البضاعة اللي دخلت — الفلوس المدفوعة عنها تشوفها بـ«فلوس خرجت» (دفعات التجار).
                </div>
                {p.devices.unpriced > 0 ? (
                    <div style={{ marginTop: 6, fontSize: 12, color: C.warn }}>
                        ⚠ {p.devices.unpriced} جهاز من مشتريات الفترة بعده بلا سعر — رقم الأجهزة رح يرتفع لما تسعّر قوائمه.
                    </div>
                ) : null}
            </div>
        );
    };

    /* ═══════════ ٦) بضاعتك بالمحل ═══════════ */
    renderInventory = () => {
        const m = this.state.movement;
        if (!m) return null;
        const inv = m.actual_detail || {};
        const dev = inv.devices || { value: 0, unpriced: 0, count: 0 };

        return (
            <div style={S.card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <div style={{ fontWeight: 700 }}>بضاعتك بالمحل هسه تسوى</div>
                    <div style={{ fontSize: 24, fontWeight: 700, direction: 'ltr' }}>{iqd(inv.total)}</div>
                </div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
                    <span style={S.chip}>أجهزة {short(dev.value)} ({dev.count} جهاز)</span>
                    <span style={S.chip}>منزلية {short(inv.household ? inv.household.value : 0)}</span>
                    <span style={S.chip}>قطع غيار {short(inv.spare ? inv.spare.value : 0)}</span>
                </div>
                {dev.unpriced > 0 ? (
                    <div style={{ marginTop: 10, fontSize: 12, color: C.warn }}>
                        ⚠ {dev.unpriced} جهاز بعده ما مسعّر — الرقم الحقيقي أعلى شوية.
                    </div>
                ) : null}
                {inv.in_transit && inv.in_transit.count > 0 ? (
                    <div style={{ marginTop: 6, fontSize: 12, color: C.muted }}>
                        وعندك بضاعة مشتراة بعدها ما وصلت المخزن بـ {iqd(inv.in_transit.value)} ({inv.in_transit.count} قائمة)
                    </div>
                ) : null}
            </div>
        );
    };

    /* ═══════════ ٧) أكو فلوس ضايعة؟ ═══════════ */
    renderLeak = () => {
        const { movement, showLeakDetails } = this.state;
        const m = movement;
        if (!m) return null;

        if (m.start.total === null) {
            return (
                <div style={Object.assign({}, S.card, { borderColor: '#fde68a' })}>
                    <div style={{ fontWeight: 700, marginBottom: 6 }}>أكو فلوس ضايعة؟</div>
                    <div style={{ fontSize: 14, marginBottom: 6 }}>
                        على الأجهزة أگدر أدقق، بس المنزلية وقطع الغيار ما أگدر أجاوب عنها
                        قبل هذا التاريخ — ما أكو «تثبيت أرقام» مسوّى قبله.
                    </div>
                    <div style={{ fontSize: 13, color: C.muted }}>
                        اضغط «ثبّت الأرقام» بالأسفل مرة وحدة، وأي فترة تبدأ بعد التثبيت
                        يصير الفحص فيها كاملاً على كل المخازن.
                    </div>
                    {m.breakdown.orphan_devices.count > 0 ? (
                        <div style={{ marginTop: 10, padding: '8px 10px', background: C.warnBg, borderRadius: 8, fontSize: 13, color: C.warn }}>
                            بس أكو شي يحتاج انتباهك هسه: <b>{m.breakdown.orphan_devices.count} جهاز
                            معلَّم مباع بلا أي طلب</b> بقيمة {iqd(m.breakdown.orphan_devices.value)}.
                        </div>
                    ) : null}
                </div>
            );
        }

        const diff = Number(m.difference) || 0;
        const transit = Number(m.breakdown.in_transit.value) || 0;
        const afterTransit = diff + transit;
        const clean = Math.abs(afterTransit) < 1000;

        return (
            <div style={Object.assign({}, S.card, { borderColor: clean ? '#a7f3d0' : '#fde68a' })}>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>أكو فلوس ضايعة؟</div>

                {clean ? (
                    <div style={{ padding: '8px 10px', background: C.okBg, borderRadius: 8, fontSize: 14, color: C.green }}>
                        لا — حسبنا شگد المفروض تسوى بضاعتك وطابقناه باللي موجود فعلاً: مطابق ✓
                    </div>
                ) : (
                    <div>
                        <div style={{ padding: '8px 10px', background: C.warnBg, borderRadius: 8, fontSize: 14, color: C.warn, marginBottom: 8 }}>
                            أكو فرق <b style={{ direction: 'ltr' }}>{iqd(Math.abs(afterTransit))}</b> دينار
                            {afterTransit < 0 ? ' ناقص من' : ' زائد على'} المخزن ما إله تفسير — يحتاج تدقيق.
                        </div>
                        <div style={{ fontSize: 13, color: C.muted }}>
                            وين ندوّر أول شي:
                            {m.breakdown.orphan_devices.count > 0
                                ? ` أكو ${m.breakdown.orphan_devices.count} جهاز معلَّم مباع بلا طلب (${iqd(m.breakdown.orphan_devices.value)}) —`
                                : ''}
                            {m.breakdown.unpriced_devices > 0
                                ? ` و ${m.breakdown.unpriced_devices} جهاز بلا سعر يخربط الحسبة —`
                                : ''}
                            {' '}والباقي غالباً تعديل يدوي على عدّ أو سعر ما انسجل.
                        </div>
                    </div>
                )}

                <button style={S.linkBtn}
                    onClick={() => this.setState({ showLeakDetails: !showLeakDetails })}>
                    {showLeakDetails ? 'إخفاء الحسبة ↑' : 'شلون حسبناها؟ ↓'}
                </button>

                {showLeakDetails ? (
                    <div style={{ borderTop: `1px solid ${C.line}`, paddingTop: 10, fontSize: 13 }}>
                        <div style={S.row}>
                            <span>بضاعتك أول الفترة (أجهزة {iqd(m.start.devices.value)} + الباقي من تثبيت {m.start.others.closing_date})</span>
                            <span style={S.num}>{iqd(m.start.total)}</span>
                        </div>
                        <div style={S.row}>
                            <span>+ اشتريت خلال الفترة</span>
                            <span style={Object.assign({}, S.num, { color: C.green })}>+ {iqd(m.purchases.total)}</span>
                        </div>
                        <div style={S.row}>
                            <span>− كلفة اللي طلع من المخزن ببيع</span>
                            <span style={Object.assign({}, S.num, { color: C.red })}>− {iqd(m.cogs.total)}</span>
                        </div>
                        <div style={Object.assign({}, S.row, { fontWeight: 700, borderTop: `1px solid ${C.line}` })}>
                            <span>= المفروض بضاعتك تسوى</span>
                            <span style={S.num}>{iqd(m.computed_end)}</span>
                        </div>
                        <div style={Object.assign({}, S.row, { fontWeight: 700 })}>
                            <span>الموجود فعلاً</span>
                            <span style={S.num}>{iqd(m.actual_end)}</span>
                        </div>
                        <div style={S.row}>
                            <span>الفرق</span>
                            <span style={S.num}>{iqd(diff)}</span>
                        </div>
                        {transit > 0 ? (
                            <div style={S.row}>
                                <span>منه مفسَّر: بضاعة اشتريتها وبعدها ما وصلت المخزن</span>
                                <span style={S.num}>{iqd(transit)}</span>
                            </div>
                        ) : null}
                        <div style={Object.assign({}, S.row, { fontWeight: 700 })}>
                            <span>الباقي بلا تفسير</span>
                            <span style={Object.assign({}, S.num, { color: clean ? C.green : C.warn })}>{iqd(afterTransit)}</span>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    };

    /* التغير بإشارة ولون: أخضر زيادة، أحمر نقصان، رمادي ثابت */
    deltaCell = (now, before) => {
        const d = (Number(now) || 0) - (Number(before) || 0);
        if (Math.abs(d) < 0.001) return <span style={{ color: C.muted }}>—</span>;
        return (
            <span style={{ color: d > 0 ? C.green : C.red, direction: 'ltr', display: 'inline-block' }}>
                {d > 0 ? '+' : '−'} {iqd(Math.abs(d))}
            </span>
        );
    };

    /* ═══════════ ٨) تثبيت أرقام اليوم ═══════════ */
    renderClosing = () => {
        const { closings, preview, closingBusy, closingMsg, showClosings, invNow } = this.state;
        const last = closings.length ? closings[0] : null;

        let lastLine = 'ما مسوّى ولا تثبيت بعد — أول تثبيت يبدأ الفحص الكامل';
        if (last) {
            const days = Math.floor((Date.now() - new Date(last.createdAt).getTime()) / 86400000);
            const when = days === 0 ? 'اليوم' : (days === 1 ? 'أمس' : `قبل ${days} يوم`);
            lastLine = `آخر تثبيت: ${when} (${last.closed_by || 'بلا اسم'})`;
        }

        /* مقارنة بضاعتك هسه بآخر تثبيت */
        const cmpRows = (last && invNow) ? [
            { t: 'أجهزة', now: invNow.devices.value, before: last.devices_value },
            { t: 'منزلية', now: invNow.household.value, before: last.household_value },
            { t: 'قطع غيار', now: invNow.spare.value, before: last.spare_value },
            { t: 'المجموع', now: invNow.total, before: last.total_value, bold: true }
        ] : null;

        return (
            <div style={S.card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                    <div>
                        <div style={{ fontWeight: 700 }}>تثبيت أرقام اليوم</div>
                        <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{lastLine}</div>
                    </div>
                    <button style={S.btn} disabled={closingBusy} onClick={this.openClosingPreview}>
                        {closingBusy ? '...' : 'ثبّت الأرقام'}
                    </button>
                </div>

                {cmpRows ? (
                    <div style={{ marginTop: 12 }}>
                        <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4 }}>
                            شنو تغيّر منذ تثبيت {String(last.createdAt).slice(0, 10)}؟
                        </div>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                            <thead>
                                <tr style={{ color: C.muted, fontSize: 12 }}>
                                    <td style={{ padding: '4px 0' }}></td>
                                    <td style={{ padding: '4px 0', textAlign: 'left' }}>وقت التثبيت</td>
                                    <td style={{ padding: '4px 0', textAlign: 'left' }}>هسه</td>
                                    <td style={{ padding: '4px 0', textAlign: 'left' }}>التغير</td>
                                </tr>
                            </thead>
                            <tbody>
                                {cmpRows.map(r => (
                                    <tr key={r.t} style={r.bold ? { fontWeight: 700, borderTop: `1px solid ${C.line}` } : {}}>
                                        <td style={{ padding: '5px 0' }}>{r.t}</td>
                                        <td style={Object.assign({}, S.num, { padding: '5px 0' })}>{iqd(r.before)}</td>
                                        <td style={Object.assign({}, S.num, { padding: '5px 0' })}>{iqd(r.now)}</td>
                                        <td style={{ padding: '5px 0', textAlign: 'left' }}>{this.deltaCell(r.now, r.before)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>
                            زيادة خضراء = دخلت بضاعة أكثر من اللي طلع ببيع — والعكس حمراء.
                            لا تنسَ: تسعير قوائم قديمة يرفع الرقم بلا بضاعة جديدة.
                        </div>
                    </div>
                ) : null}

                {closingMsg ? <div style={{ fontSize: 13, color: C.muted, marginTop: 8 }}>{closingMsg}</div> : null}

                {preview ? (
                    <div style={{ border: `1px solid ${C.line}`, borderRadius: 8, padding: 12, marginTop: 10, background: '#f8fafc' }}>
                        {preview.already_closed_today ? (
                            <div style={{ color: C.warn, fontSize: 13 }}>
                                اليوم مثبَّت من قبل ({preview.existing_closing ? preview.existing_closing.closed_by : ''}) — مرة وحدة باليوم تكفي.
                                <button style={Object.assign({}, S.btnGhost, { marginRight: 10 })}
                                    onClick={() => this.setState({ preview: null })}>تمام</button>
                            </div>
                        ) : (
                            <div>
                                <div style={{ fontSize: 13, marginBottom: 8 }}>
                                    رح نثبّت أن بضاعتك اليوم تسوى{' '}
                                    <b style={{ direction: 'ltr' }}>{iqd(preview.inventory.total)}</b> دينار
                                    (أجهزة {short(preview.inventory.devices.value)} ·
                                    منزلية {short(preview.inventory.household.value)} ·
                                    قطع غيار {short(preview.inventory.spare.value)})
                                    {preview.inventory.devices.unpriced > 0
                                        ? <span style={{ color: C.warn }}> — انتبه: {preview.inventory.devices.unpriced} جهاز بلا سعر</span>
                                        : ''}
                                </div>
                                <button style={S.btn} disabled={closingBusy} onClick={this.confirmClosing}>تأكيد</button>
                                <button style={Object.assign({}, S.btnGhost, { marginRight: 10 })}
                                    onClick={() => this.setState({ preview: null })}>تراجع</button>
                            </div>
                        )}
                    </div>
                ) : null}

                {closings.length > 0 ? (
                    <div>
                        <button style={S.linkBtn}
                            onClick={() => this.setState({ showClosings: !showClosings })}>
                            {showClosings ? 'إخفاء التثبيتات السابقة ↑' : 'التثبيتات السابقة ↓'}
                        </button>
                        {showClosings ? (
                            <div style={{ borderTop: `1px solid ${C.line}`, paddingTop: 8, fontSize: 13 }}>
                                {closings.map((cl, i) => {
                                    const prev = closings[i + 1];   /* القائمة تنازلية — اللي قبله زمنياً هو التالي */
                                    return (
                                        <div style={S.row} key={cl.id}>
                                            <span style={{ color: C.muted }}>
                                                {String(cl.createdAt).slice(0, 10)} — {cl.closed_by || 'بلا اسم'}
                                                {cl.unpriced_count > 0 ? <span style={{ color: C.warn }}> ({cl.unpriced_count} بلا سعر)</span> : ''}
                                            </span>
                                            <span style={S.num}>
                                                {iqd(cl.total_value)}
                                                {prev ? <span style={{ fontSize: 12, marginLeft: 6 }}> ({this.deltaCell(cl.total_value, prev.total_value)})</span> : null}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        );
    };

    render() {
        const { from, to, loading, error, searched } = this.state;

        return (
            <div style={S.page}>
                <div style={S.wrap}>
                    <div style={S.card}>
                        <div style={{ fontSize: 20, fontWeight: 700, color: C.ink, marginBottom: 2 }}>التقرير المالي</div>
                        <div style={{ fontSize: 13, color: C.muted, marginBottom: 12 }}>
                            شگد فلوس دخلت وخرجت، شگد مشتريات ومصاريف، وشگد تسوى بضاعتك — بالدينار العراقي
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'flex-end' }}>
                            <div>
                                <label style={S.label}>من</label>
                                <DatePicker selected={from} onChange={d => this.setState({ from: d })} dateFormat="dd/MM/yyyy" />
                            </div>
                            <div>
                                <label style={S.label}>إلى</label>
                                <DatePicker selected={to} onChange={d => this.setState({ to: d })} dateFormat="dd/MM/yyyy" />
                            </div>
                            <button style={S.btn} disabled={loading} onClick={this.fetchAll}>
                                {loading ? 'دقيقة...' : 'احسبلي'}
                            </button>
                        </div>
                    </div>

                    {error ? <div style={S.err}>{error}</div> : null}

                    {this.renderCashNow()}
                    {searched ? this.renderNet() : null}
                    {searched ? this.renderMoneyIn() : null}
                    {searched ? this.renderMoneyOut() : null}
                    {searched ? this.renderExpenses() : null}
                    {searched ? this.renderPurchases() : null}
                    {searched ? this.renderInventory() : null}
                    {searched ? this.renderLeak() : null}
                    {this.renderClosing()}
                </div>
            </div>
        );
    }
}

export default FinanceReport;
